import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { label: '安全须知', path: '/category/safety' },
      { label: '道具选择', path: '/category/equipment' },
      { label: '基础技巧', path: '/category/basics' },
      { label: '进阶教程', path: '/category/advanced' },
      { label: '信任建立', path: '/category/trust' },
      { label: '事后关怀', path: '/category/aftercare' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 text-background-50 font-semibold text-lg mb-4 whitespace-nowrap cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-link text-lg"></i>
              </span>
              捆绑调教完全指南
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              帮助成人伴侣在安全、自愿、理性的前提下探索捆绑调教的乐趣与边界。SSC原则：安全（Safe）、理性（Sane）、自愿（Consensual）。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-background-50 font-semibold text-sm mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-foreground-400 hover:text-background-50 text-sm transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 捆绑调教完全指南。本站内容仅供成人教育参考，请遵循当地法律法规。
          </p>
          <p className="text-foreground-500 text-xs">
            安全 · 理性 · 自愿
          </p>
        </div>
      </div>
    </footer>
  );
}